import(/* webpackMode: "eager" */ "/app/next/app/[root]/(standard)/(client-data)/error.tsx");
